(() => {
 'use strict';
 if(window.__R290_MEDIA__)return;
 const boot=JSON.parse(document.getElementById('tos-media-290').textContent);
 const originals={"title":"Picual, de aproape.","close":"Închide detaliile sticlei","view":"Sticla mărită. Săgeți pentru rotire, Home pentru față.","intro":"Forma sticlei. Textura etichetei. Fiecare detaliu, în ritmul tău.","modes":"Alege detaliul","bottle":"Sticla","label":"Eticheta","cap":"Capacul","left":"Rotește spre stânga","reset":"Din față","right":"Rotește spre dreapta","zoom":"Mărire controlată","out":"Micșorează imaginea","in":"Mărește imaginea","hint":"Trage orizontal pentru rotire.","origin":"Randare din modelul 3D.","rotateHint":"Trage orizontal sau folosește săgețile.","zoomHint":"Mărește cu +. Revii cu −.","loading":"Se încarcă detaliul…","angleError":"Acest unghi nu s-a încărcat. Imaginea curentă rămâne disponibilă.","detailError":"Detaliul nu s-a încărcat. Am păstrat vederea sticlei.","imageError":"Imaginea nu s-a încărcat. Alege Sticla pentru a încerca din nou.","altFull":"sticla întreagă","altLabel":"detaliul etichetei","altCap":"detaliul capacului","inline":"Rotește sticla Picual 500 ml. Trage orizontal sau folosește săgețile.","expand":"Vezi de aproape sticla","format500":"Picual · 500 ml","format1l":"Picual · 1 L","tennis":"Tennis","edition1l":"Triathlon auriu"};
 const label=k=>k==='reset'&&boot.cleanBottleUI!==false?(boot.labels?.resetRotation||'Resetează rotirea'):(boot.labels?.[k]||originals[k]);
 const escape=s=>String(s).replaceAll('&','&amp;').replaceAll('<','&lt;').replaceAll('>','&gt;').replaceAll('"','&quot;');
 const markup=s=>Object.entries(originals).sort((a,b)=>b[1].length-a[1].length).reduce((html,[k,v])=>html.replaceAll(v,escape(label(k))),s);
 const base=new URL('./',document.currentScript.src).href,frames=72,records=new Map(),expanded=new Map(),decoded=new Map();
 const full500=base+'3os-290-tennis-500-poster.webp';
 const fallback={500:full500,1000:base+'3os-r11-triathlon-1l-poster.webp'};
 const defaultPaths={500:{full:full500,label:base+'3os-r6-tennis-label.jpg',cap:base+'3os-r6-tennis-cap.jpg'},1000:{full:base+'3os-290-gold-alpha-000.webp',label:base+'3os-290-gold-label.webp',cap:base+'3os-290-gold-cap.webp'}};
 const paths=boot.paths||defaultPaths;
 const frameURL=(index,format='500')=>{const n=(index%frames+frames)%frames;return n===0?paths[format].full:boot.frames[format][n];};
 const icon='<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"/><path d="m15.4 15.4 4.6 4.6M7.5 10.5h6M10.5 7.5v6"/></svg>';
 const config={zoomMax:Math.max(1.2,Math.min(1.8,boot.zoomMax||1.6)),zoomStep:boot.zoomStep||.2,dragThreshold:boot.dragThreshold||9,prewarmNeighbors:boot.prewarmNeighbors!==false,rotationRadiansPerPixel:Math.max(.004,Math.min(.025,boot.rotationRadiansPerPixel||.012)),rotationBuffer:Math.max(4,Math.min(16,boot.rotationBuffer||10))};
 config.lockInlineTouch=boot.lockInlineTouch!==false;
 config.cleanBottleUI=boot.cleanBottleUI!==false;
 let dialog,active=null,returnFocus=null,openScroll=0,origin=null;
 const angles=new Map(),normalize=n=>(n%frames+frames)%frames;
 function remember(){if(active&&dialog?._record)angles.set(active.format,dialog._record.index);}
 function sourceAngle(button,format){
  origin=null;
  for(const [stage,record]of records)if(stage===button||stage.contains(button)){origin={record,format};return record.index;}
  const native=window.__THREE_OLIVES_270_R2__;
  if(native)for(const [stage,record]of native.records)if(stage===button||stage.contains(button)){
   const radians=native.viewer.activeRecord===record&&native.viewer.activeModel?native.viewer.activeModel.rotation.y-record.yaw:record.pendingRotation||0;
   const index=normalize(Math.round(radians*frames/(2*Math.PI)));origin={native:record,format};return index;
  }
  return angles.get(format)||0;
 }
 function returnAngle(){
  if(!origin)return;const source=origin,index=angles.get(source.format)||0;origin=null;
  if(source.record?.surface.isConnected)show(source.record,index);
  else if(source.native?.stage.isConnected){
   const native=window.__THREE_OLIVES_270_R2__,record=source.native;
   const radians=index*2*Math.PI/frames;record.pendingRotation=radians;
   native.viewer.activate(record,{focus:false});
  }
 }
 let handledTouch=null;
 // One shared release receipt covers scene targets, rail and gallery. Consuming
 // compatibility mouse events also prevents a closed dialog's touch from moving
 // focus to (or clicking) a page control now underneath the same coordinates.
 document.addEventListener('pointerdown',()=>{handledTouch=null;},true);
 for(const type of ['mousedown','mouseup','click'])document.addEventListener(type,e=>{
  if(!e.isTrusted||e.detail===0||!handledTouch||performance.now()-handledTouch.at>=1000)return;
  // WebKit can retarget the compatibility tail into the opening dialog and
  // transform its coordinates during the entrance animation. A fresh physical
  // gesture clears this receipt on pointerdown; the remaining mouse tail is
  // therefore already handled, regardless of where it is retargeted.
  e.preventDefault();e.stopImmediatePropagation();if(type==='click')handledTouch=null;
 },true);
 function activateTouch(e,button,action){handledTouch={button,id:e.pointerId,x:e.clientX,y:e.clientY,at:performance.now()};action();}
 const touchBound=new WeakSet();
 function bindTouchButtons(root){
  if(touchBound.has(root))return;touchBound.add(root);let press=null;
  const cancel=()=>{press=null;};
  document.addEventListener('pointerdown',e=>{
   cancel();if(e.pointerType!=='touch'||!e.isPrimary||e.button!==0||e.ctrlKey||e.metaKey||e.altKey||e.shiftKey)return;
   const button=e.target.closest?.('button');
   if(button&&root.contains(button)&&!button.disabled)press={button,id:e.pointerId,x:e.clientX,y:e.clientY};
  },true);
  root.addEventListener('pointermove',e=>{if(press&&e.pointerId===press.id&&Math.hypot(e.clientX-press.x,e.clientY-press.y)>=config.dragThreshold)cancel();},true);
  root.addEventListener('pointerup',e=>{
   if(!press||e.pointerId!==press.id)return;
   const {button,x,y}=press;cancel();const r=button.getBoundingClientRect();
   if(!button.isConnected||button.disabled||!r.width||!r.height||Math.hypot(e.clientX-x,e.clientY-y)>=config.dragThreshold||e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)return;
   activateTouch(e,button,()=>{button.focus({preventScroll:true});button.click();});
  },true);
  ['pointercancel','contextmenu','close'].forEach(type=>root.addEventListener(type,cancel,true));
  document.addEventListener('scroll',cancel,true);window.addEventListener('blur',cancel);
 }
 const describe=f=>f==='1000'?label('format1l'):label('format500');
 // Keep the supplied Cycles render/materials. Only presentation is interpolated:
 // two adjacent decoded angles, premultiplied-alpha blended on one canvas.
 // No model/material substitution, inertia, layout translation or invented angle.
 const motionCache=new Map(),motionQueue=new Map();let motionLoads=0,motionOwner=null;
 const motionBudget=64*1024*1024;
 const motionBase=320;
 config.rotationMotionWidth=[448,640,896].includes(boot.rotationMotionWidth)?boot.rotationMotionWidth:640;
 const motionURL=(index,format,size)=>{
  const url=boot.frames[format][normalize(index)];
  return size===896?url:url.replace(/\.webp(?=\?|$)/,'_'+size+'x.webp');
 };
 function trimMotion(){
  let bytes=[...motionCache.values()].reduce((n,e)=>n+(e.bytes||0),0);
  // Keep a light all-angle safety ring for both formats. A complete active
  // 320px sequence is ~35 MiB, not 275 MiB of full-size decoded surfaces.
  const priority=e=>(e.size===motionBase&&e.index%3===0?3:e.size===motionBase&&e.format===motionOwner?.format?2:e.size>motionBase?1:0);
  for(const [url,e]of [...motionCache].sort((a,b)=>priority(a[1])-priority(b[1])||a[1].at-b[1].at)){
   if(bytes<=motionBudget)break;
   if(e.image||e.failed){bytes-=e.bytes;motionCache.delete(url);}
  }
 }
 function wakeMotion(record,entry){
  // A pending image can be shared by an inline bottle and its open gallery.
  // Wake the current consumer too, not only the record that initiated its fetch.
  for(const current of new Set([record,...records.values(),dialog?._record])){
   const f=current?.flow;if(!f||f.raf||f.committing||current.pinching||current.enabled===false||!current.image.isConnected||document.hidden||f.format!==entry.format)continue;
   const d=Math.abs(normalize(entry.index-Math.floor(f.target)+36)-36);
   if(f.dragging&&d<=1)f.raf=requestAnimationFrame(t=>tickFlow(current,t));
  }
 }
 function pumpMotion(){
  while(motionLoads<4&&motionQueue.size){
   const [url,request]=[...motionQueue].sort((a,b)=>b[1].priority-a[1].priority)[0];motionQueue.delete(url);
   if(motionCache.has(url))continue;
   const entry={at:performance.now(),image:null,bytes:0,index:request.index,format:request.format,size:request.size};motionCache.set(url,entry);motionLoads++;
   const img=new Image();img.decoding='async';
   const finish=()=>{motionLoads--;trimMotion();pumpMotion();};
   img.onload=()=>img.decode().catch(()=>{}).then(()=>{entry.image=img;entry.bytes=img.naturalWidth*img.naturalHeight*4;entry.at=performance.now();finish();wakeMotion(request.record,entry);});
   img.onerror=()=>{entry.failed=performance.now();finish();};img.src=url;
  }
 }
 function requestMotion(record,angle,direction=0,radius=config.rotationBuffer){
  const f=record.flow;if(!f||!boot.frames[record.format])return;
  const now=performance.now(),center=Math.round(angle),sign=direction<0?-1:1;
  if(f.interacting)motionOwner=record;
  // Old queued lookahead must not compete with a new gesture, format or reversal.
  for(const [url,q]of motionQueue)if(q.record===record)motionQueue.delete(url);
  const add=(index,size,priority)=>{
   index=normalize(index);const url=motionURL(index,record.format,size),entry=motionCache.get(url);
   if(entry){if(!entry.failed||now-entry.failed<2000)return;motionCache.delete(url);}
   const q=motionQueue.get(url),p=priority+(f.interacting?2000:0);
   if(!q||q.priority<p)motionQueue.set(url,{record,index,format:record.format,size,priority:p});
  };
  // Closest current angles first; then coarse all-around coverage, then detail.
  [center,center+1,center-1,center+2*sign,center-2*sign].forEach((n,i)=>add(n,motionBase,1000-i));
  for(let i=0;i<24;i++){const n=normalize(Math.round(center/3)*3+(i%2?1:-1)*Math.ceil(i/2)*3);add(n,motionBase,900-i);}
  if(f.interacting){
   for(let i=0;i<Math.min(radius,4);i++){add(center+i*sign,f.size,600-i*2);add(center-i*sign,f.size,599-i*2);}
   for(let i=0;i<frames;i++){const n=center+(i%2?1:-1)*Math.ceil(i/2);add(n,motionBase,400-i);}
  }
  pumpMotion();
 }
 function flowState(record){
  if(record.flow&&record.flow.format===record.format)return record.flow;
  stopFlow(record,true);
  const constrained=(navigator.deviceMemory&&navigator.deviceMemory<=4)||(navigator.hardwareConcurrency&&navigator.hardwareConcurrency<=4);
  return record.flow={format:record.format,shown:record.index,target:record.index,size:constrained?448:config.rotationMotionWidth,raf:0,last:0,dragging:false,committing:false,canvas:null,visible:false,interacting:record.surface.classList.contains('r290-view')};
 }
 function mirrorMotion(record){
  const f=record.flow;if(!f?.canvas)return;
  const img=record.image,css=getComputedStyle(img),c=f.canvas;
  // Calibrated poster geometry is resolved only on entry/resize, never per frame.
  // getComputedStyle is live: interleaving its reads with canvas style writes
  // caused repeated layout/style passes on the first drag. Read once, then write.
  const values=Object.fromEntries(['width','height','left','right','top','bottom','transform','transformOrigin','objectFit','objectPosition','filter','borderRadius','margin'].map(key=>[key,css[key]]));
  const zIndex=css.zIndex==='auto'?'1':css.zIndex,staticImage=css.position==='static';
  const left=staticImage?img.offsetLeft:0,top=staticImage?img.offsetTop:0;
  Object.assign(c.style,values,{position:'absolute',pointerEvents:'none',zIndex});
  if(staticImage){c.style.left=left+'px';c.style.top=top+'px';c.style.right='auto';c.style.bottom='auto';}
  if(record.surface.classList.contains('r290-view')){
   c.style.left='50%';c.style.top='50%';c.style.right='auto';c.style.bottom='auto';
   c.style.transform='translate(-50%, -50%) translateY(var(--r293-y, 0px)) scale(var(--r293-scale, var(--r290-zoom, 1)))';
  }
 }
 function startCanvas(record){
  const f=record.flow;
  if(!f.canvas){
   const c=document.createElement('canvas');c.className='r297-motion';c.setAttribute('aria-hidden','true');
   c.width=f.size;c.height=Math.round(f.size*1.25);record.image.after(c);f.canvas=c;f.context=c.getContext('2d',{alpha:true});
   f.observer=new ResizeObserver(()=>mirrorMotion(record));f.observer.observe(record.image);
  }
  if(!f.visible){
   record.onFrame?.(Math.round(normalize(f.shown))||1);
   f.visibility=record.image.style.visibility;mirrorMotion(record);record.image.style.visibility='hidden';f.canvas.hidden=false;f.visible=true;
  }
 }
 function hideMotion(record){
  const f=record.flow;if(!f?.visible)return;
  f.canvas.hidden=true;record.image.style.visibility=f.visibility||'';f.visible=false;record.onFrame?.(record.index);
 }
 function stopFlow(record,remove=false){
  const f=record.flow;if(!f)return;
  cancelAnimationFrame(f.raf);f.raf=0;f.dragging=false;f.committing=false;
  for(const [url,q]of motionQueue)if(q.record===record)motionQueue.delete(url);
  if(remove){hideMotion(record);f.observer?.disconnect();f.canvas?.remove();record.flow=null;}
 }
 function paintMotion(record,angle){
  const f=record.flow,low=Math.floor(angle);let mix=angle-low,size=f.size,actual=angle;
  let a=motionCache.get(motionURL(low,record.format,size)),b=motionCache.get(motionURL(low+1,record.format,size));
  if(!a?.image||(!b?.image&&mix>.001)){
   size=motionBase;a=motionCache.get(motionURL(low,record.format,size));b=motionCache.get(motionURL(low+1,record.format,size));
  }
  if(!a?.image||(!b?.image&&mix>.001)){
   // Missing fine angles never freeze a fast swipe behind the pointer. Use the
   // closest original from the small ring until its exact neighbour is decoded.
   // No blending of nonadjacent labels or synthetic material is introduced.
   a=null;b=null;mix=0;const center=Math.round(angle);
   for(let n=0;n<=3&&!a;n++)for(const sign of [1,-1]){const e=motionCache.get(motionURL(center+n*sign,record.format,motionBase));if(e?.image){a=e;actual=center+n*sign;break;}}
   if(!a)return false;
  }
  const key=size+':'+actual+':'+mix;
  if(f.visible&&key===f.paintKey)return true;
  startCanvas(record);const ctx=f.context,w=f.canvas.width,h=f.canvas.height;
  ctx.clearRect(0,0,w,h);ctx.globalCompositeOperation='source-over';ctx.globalAlpha=1-mix;ctx.drawImage(a.image,0,0,w,h);
  if(mix>.001){ctx.globalCompositeOperation='lighter';ctx.globalAlpha=mix;ctx.drawImage(b.image,0,0,w,h);}
  ctx.globalCompositeOperation='source-over';ctx.globalAlpha=1;
  a.at=performance.now();if(b)b.at=a.at;
  f.paintKey=key;f.shown=actual;record.index=normalize(Math.round(actual));
  if(record.surface.dataset.frame!==String(record.index))record.surface.dataset.frame=String(record.index);
  if(record.reset&&record.reset.hidden!==(record.index===0))record.reset.hidden=record.index===0;
  if(record.status?.textContent)record.status.textContent='';return true;
 }
 function tickFlow(record,time){
  const f=record.flow;f.raf=0;
  if(record.enabled===false||record.pinching||!record.image.isConnected||document.hidden){stopFlow(record);return;}
  f.last=time;
  if(f.needsBuffer){f.needsBuffer=false;requestMotion(record,f.target,f.direction);}
  const delta=f.target-f.shown;
  // Direct manipulation has no velocity cap or easing queue. A fast finger is
  // not an animation to replay later. RAF draws the newest angle at any refresh.
  const step=delta;
  paintMotion(record,f.shown+step);
  if(!f.dragging){
   if(!f.committing){f.committing=true;show(record,normalize(Math.round(f.target)),true);}
  }
  // No decode-polling/idle RAF loop. Input and the relevant image completion
  // wake the next frame; release commits the original, not a catch-up animation.
 }
 function load(url){
  if(decoded.has(url))return decoded.get(url);
  const promise=new Promise((resolve,reject)=>{const img=new Image();img.decoding='async';img.onload=()=>img.decode().catch(()=>{}).then(()=>resolve(img));img.onerror=()=>reject(Error('Image unavailable'));img.src=url;});
  decoded.set(url,promise);while(decoded.size>4)decoded.delete(decoded.keys().next().value);
  promise.catch(()=>decoded.delete(url));return promise;
 }
 async function show(record,index,queued=false){
  if(!queued){record.rotationIntent=null;stopFlow(record);}
  const next=(index%frames+frames)%frames,ticket=++record.ticket;record.wanted=next;
  try{
   const image=await load(frameURL(next,record.format));if(ticket!==record.ticket||!record.image.isConnected)return;
   const picture=record.image.closest('picture');picture?.querySelectorAll('source').forEach(n=>{n.srcset=image.src;});
   record.image.srcset=image.src;record.image.src=image.src;record.index=next;
   if(record.flow){record.flow.shown=record.flow.target=next;record.flow.committing=false;}
   hideMotion(record);record.onFrame?.(next);
   record.surface.dataset.frame=String(next);if(record.reset)record.reset.hidden=next===0;
   if(record.status)record.status.textContent='';
   if(!navigator.connection?.saveData)for(const near of [next-1,next+1])load(frameURL(near,record.format)).catch(()=>{});
  }catch{
   if(ticket!==record.ticket)return;record.wanted=record.index;if(record.flow)record.flow.committing=false;
   if(record.status)record.status.textContent=label('angleError');
  }
 }
 function rotateTo(record,index){
  const f=flowState(record),direction=index-f.target;
  record.ticket++;record.wanted=normalize(Math.round(index));f.committing=false;f.target=index;f.inputAt=performance.now();
  f.interacting=true;f.direction=direction;f.needsBuffer=true;
  if(!f.raf)f.raf=requestAnimationFrame(t=>tickFlow(record,t));
 }
 function rotate(record,steps){show(record,record.wanted+steps);}
 function bindRotation(surface,record){
  let drag=null;
  const warmNearby=(radius=3)=>{if(!boot.frames[record.format])return;flowState(record);requestMotion(record,record.flow.shown,0,radius);};
  // A small bidirectional buffer only for visible bottles; no full turn on load.
  if(config.prewarmNeighbors&&record.surface!==surface){
   const warm=new IntersectionObserver(entries=>{
    if(!entries.some(e=>e.isIntersecting&&e.intersectionRatio>=.5)||document.hidden||navigator.connection?.saveData)return;
    if(!boot.frames[record.format])return;
    warm.disconnect();
    warmNearby();
   },{threshold:[.5]});
   warm.observe(surface);const dispose=record.destroy;record.destroy=()=>{warm.disconnect();dispose?.();};
  }
  surface.addEventListener('pointerenter',()=>{if(!navigator.connection?.saveData)warmNearby(5);},{passive:true});
  surface.addEventListener('pointerdown',e=>{
   if(e.button!==0||e.ctrlKey||e.metaKey||e.altKey||e.shiftKey||e.target.closest('button:not(.r290-turn):not(.r291-hit)'))return;
   if(e.pointerType==='touch'&&!e.isPrimary){drag=null;if(record.flow)record.flow.dragging=false;return;}
   const f=flowState(record);f.dragging=true;warmNearby(5);
   drag={id:e.pointerId,x:e.clientX,y:e.clientY,index:f.shown,axis:null,lastDx:0,direction:0};
   try{surface.setPointerCapture(e.pointerId);}catch{}
  });
  surface.addEventListener('pointermove',e=>{
   if(!drag||drag.id!==e.pointerId||record.enabled===false||record.pinching)return;
   const dx=e.clientX-drag.x,dy=e.clientY-drag.y;
   if(!drag.axis&&Math.max(Math.abs(dx),Math.abs(dy))>=config.dragThreshold)drag.axis=e.pointerType==='touch'&&config.lockInlineTouch&&!record.surface.classList.contains('r290-view')?'rotate':Math.abs(dx)>Math.abs(dy)*1.12?'rotate':'scroll';
   if(drag.axis==='scroll'){try{surface.releasePointerCapture(drag.id);}catch{}drag=null;if(record.flow)record.flow.dragging=false;return;}
   if(drag.axis!=='rotate')return;
   const factor=config.rotationRadiansPerPixel*frames/(2*Math.PI),direction=Math.sign(dx-drag.lastDx);
   if(direction&&drag.direction&&direction!==drag.direction)drag.index=record.flow.shown-dx*factor;
   if(direction)drag.direction=direction;drag.lastDx=dx;
   rotateTo(record,drag.index+dx*factor);
  },{passive:true});
  const release=()=>{const moved=drag?.axis==='rotate';drag=null;const f=record.flow;if(!f)return;f.dragging=false;f.inputAt=performance.now();if(moved||f.visible){f.target=Math.round(f.target);f.needsBuffer=true;if(!f.raf)f.raf=requestAnimationFrame(t=>tickFlow(record,t));}};['pointerup','pointercancel','lostpointercapture'].forEach(type=>surface.addEventListener(type,release));
  const dispose=record.destroy;record.destroy=()=>{stopFlow(record,true);dispose?.();};
  surface.addEventListener('keydown',e=>{
   if(record.enabled===false)return;
   if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();rotate(record,e.key==='ArrowLeft'?-1:1);}
   if(e.key==='Home'){e.preventDefault();show(record,0);}
  });
 }
 // Formate uses tightly cropped posters rather than full frame canvases. Keep
 // those originals in flow and align the lazy 360 layer by the photographed
 // bottle's centre/base, not the transparent canvas edges. Source pixels are
 // measured in evidence/inline-geometry.json; uniform scaling preserves shape.
 const posterGeometry=boot.inlineGeometry||{
  500:{source:{width:239,height:1057,top:51,bottom:1056,center:119.5},frame:{width:896,height:1120,top:132,bottom:977,center:448}},
  1000:{source:{width:240,height:1057,top:1,bottom:1056,center:119.5},frame:{width:896,height:1120,top:132,bottom:977,center:448}}
 };
 function registerPoster(stage,button,getFormat){
  if(records.has(stage))return records.get(stage);
  const original=stage.querySelector('img');if(!original)return;
  const image=document.createElement('img');image.className='r294-inline-frame';image.alt='';image.setAttribute('aria-hidden','true');image.draggable=false;image.hidden=true;
  const status=document.createElement('span');status.className='r290-sr';status.setAttribute('role','status');
  const record={surface:stage,image,original,status,index:0,wanted:0,ticket:0,format:String(getFormat()),source:original.getAttribute('src'),visibility:original.style.visibility};
  const position=()=>{
   const g=posterGeometry[record.format];if(!g||!original.complete||!original.naturalWidth)return;
   const box=stage.getBoundingClientRect(),r=original.getBoundingClientRect(),stageCSS=getComputedStyle(stage),css=getComputedStyle(original);
   // offsetWidth/Height round to whole pixels; that creates a visible jump on
   // narrow mobile bottles. Use the fractional CSS border box for transforms.
   const size=(axis,sides,fallback)=>{let n=parseFloat(stageCSS[axis]);if(stageCSS.boxSizing!=='border-box')for(const side of sides)n+=(parseFloat(stageCSS['padding'+side])||0)+(parseFloat(stageCSS['border'+side+'Width'])||0);return n>0?n:fallback;};
   const sx=box.width/size('width',['Left','Right'],stage.offsetWidth)||1,sy=box.height/size('height',['Top','Bottom'],stage.offsetHeight)||1;
   const w=r.width/sx,h=r.height/sy,fit=css.objectFit;
   const scale=fit==='cover'?Math.max(w/g.source.width,h/g.source.height):Math.min(w/g.source.width,h/g.source.height);
   const [px,py]=css.objectPosition.split(' ').map(n=>parseFloat(n)/100);
   const x=(r.left-box.left)/sx+(w-g.source.width*scale)*(Number.isFinite(px)?px:.5),y=(r.top-box.top)/sy+(h-g.source.height*scale)*(Number.isFinite(py)?py:.5);
   const s=scale*(g.source.bottom-g.source.top)/(g.frame.bottom-g.frame.top);
   Object.assign(image.style,{left:(x+g.source.center*scale-g.frame.center*s)+'px',top:(y+g.source.bottom*scale-g.frame.bottom*s)+'px',width:g.frame.width*s+'px',height:g.frame.height*s+'px',filter:css.filter});
  };
  const restore=()=>{image.hidden=true;original.style.visibility=record.visibility;};
  record.onFrame=index=>{position();if(index===0){restore();return;}image.hidden=false;original.style.visibility='hidden';};
  record.sync=()=>{
   const format=String(getFormat()),source=original.getAttribute('src');
   if(format!==record.format||source!==record.source){record.ticket++;stopFlow(record,true);record.rotationIntent=null;record.format=format;record.source=source;record.index=record.wanted=0;stage.dataset.frame='0';status.textContent='';restore();}
   position();
  };
  const observer=new ResizeObserver(position);observer.observe(stage);observer.observe(original);original.addEventListener('load',record.sync);
  record.destroy=()=>{observer.disconnect();original.removeEventListener('load',record.sync);restore();image.remove();status.remove();};
  stage.append(image,status);records.set(stage,record);bindRotation(button,record);record.sync();return record;
 }
 function createDialog(){
  if(dialog)return;
  dialog=document.createElement('dialog');dialog.className='r290-dialog';dialog.setAttribute('aria-labelledby','r290-title');
  dialog.innerHTML=markup('<header class="r290-head"><h2 class="r290-title" id="r290-title">Picual, de aproape.<span class="r290-subtitle"></span></h2><button type="button" class="r290-close" aria-label="Închide detaliile sticlei">×</button></header><div class="r290-body"><div class="r290-view" tabindex="0" role="group" aria-label="Sticla mărită. Săgeți pentru rotire, Home pentru față."><img width="1120" height="1400" draggable="false" alt=""></div><aside class="r290-options"><p>Forma sticlei. Textura etichetei. Fiecare detaliu, în ritmul tău.</p><div class="r290-modes" role="group" aria-label="Alege detaliul"><button type="button" class="r290-mode" data-kind="full" aria-pressed="true">Sticla</button><button type="button" class="r290-mode" data-kind="label" aria-pressed="false">Eticheta</button><button type="button" class="r290-mode" data-kind="cap" aria-pressed="false">Capacul</button></div><div class="r290-rotate"><button type="button" data-rotate="-1" aria-label="Rotește spre stânga">‹</button><button type="button" data-reset>Din față</button><button type="button" data-rotate="1" aria-label="Rotește spre dreapta">›</button></div><div class="r290-zoom" role="group" aria-label="Mărire controlată"><button type="button" data-zoom="-1" aria-label="Micșorează imaginea">−</button><output aria-live="polite">100%</output><button type="button" data-zoom="1" aria-label="Mărește imaginea">+</button></div></aside></div><footer class="r290-foot"><span data-hint>Trage orizontal pentru rotire.</span><span data-origin>Randare din modelul 3D.</span><span role="status" class="r290-sr" data-status></span></footer>');
  document.body.append(dialog);
  const view=dialog.querySelector('.r290-view');
  dialog.querySelector('[data-status]').className='r290-status';
  const record={surface:view,image:view.querySelector('img'),index:0,wanted:0,ticket:0,enabled:true,status:dialog.querySelector('[data-status]')};
  dialog._record=record;bindRotation(view,record);
  const pointers=new Map();let pinch=null;
  view.addEventListener('pointerdown',e=>{
   if(e.pointerType!=='touch')return;pointers.set(e.pointerId,{x:e.clientX,y:e.clientY});
   if(pointers.size===2){const [a,b]=[...pointers.values()];pinch={distance:Math.hypot(a.x-b.x,a.y-b.y),zoom:active.zoom};record.pinching=true;}
  });
  view.addEventListener('pointermove',e=>{
   if(!pointers.has(e.pointerId))return;pointers.set(e.pointerId,{x:e.clientX,y:e.clientY});
   if(pointers.size===2&&pinch){const [a,b]=[...pointers.values()];setZoom(pinch.zoom*Math.hypot(a.x-b.x,a.y-b.y)/Math.max(1,pinch.distance));}
  });
  const endPinch=e=>{pointers.delete(e.pointerId);if(!pointers.size){record.pinching=false;pinch=null;}};
  ['pointerup','pointercancel','lostpointercapture'].forEach(type=>view.addEventListener(type,endPinch));
  dialog.querySelector('.r290-close').onclick=()=>dialog.close();
  dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
  dialog.addEventListener('keydown',e=>{
   if(e.key!=='Tab')return;
   const stops=[...dialog.querySelectorAll('button:not([disabled]),[tabindex="0"]')].filter(el=>el.getClientRects().length);
   const first=stops[0],last=stops.at(-1);
   if(e.shiftKey&&(document.activeElement===first||!dialog.contains(document.activeElement))){e.preventDefault();last?.focus();}
   else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first?.focus();}
  });
  dialog.addEventListener('close',()=>{remember();record.ticket++;stopFlow(record,true);record.enabled=false;record.pinching=false;pointers.clear();pinch=null;document.documentElement.style.overflow=dialog._previousOverflow||'';window.scrollTo({top:openScroll,behavior:'instant'});returnFocus?.focus({preventScroll:true});active=null;returnAngle();});
  dialog.querySelectorAll('[data-kind]').forEach(button=>button.onclick=()=>setMode(button.dataset.kind));
  dialog.querySelectorAll('[data-rotate]').forEach(button=>button.onclick=()=>rotate(record,Number(button.dataset.rotate)));
  dialog.querySelector('[data-reset]').onclick=()=>{setZoom(1);show(record,0);};
  dialog.querySelectorAll('[data-zoom]').forEach(button=>button.onclick=()=>setZoom(active.zoom+Number(button.dataset.zoom)*config.zoomStep));
  view.addEventListener('keydown',e=>{if(['+','=','-','_'].includes(e.key)){e.preventDefault();setZoom(active.zoom+(['+','='].includes(e.key)?1:-1)*config.zoomStep);}});
  // Only the isolated detail surface owns wheel zoom; ordinary page scroll and
  // browser Ctrl+wheel accessibility zoom remain untouched.
  let wheelAmount=0,wheelAt=0;
  view.addEventListener('wheel',e=>{
   if(!dialog.open||!active||e.ctrlKey||!e.deltaY)return;
   e.preventDefault();const now=performance.now();if(now-wheelAt>180)wheelAmount=0;wheelAt=now;
   wheelAmount+=e.deltaY*(e.deltaMode===1?16:e.deltaMode===2?view.clientHeight:1);
   const steps=Math.trunc(wheelAmount/40);if(steps){wheelAmount-=steps*40;setZoom(active.zoom-Math.max(-3,Math.min(3,steps))*.1);}
  },{passive:false});
  view.addEventListener('dblclick',e=>{
   if(!active)return;e.preventDefault();setZoom(active.zoom>1?1:config.zoomMax);
  });
 }
 function setZoom(zoom){
  if(!active)return;active.zoom=Math.max(1,Math.min(config.zoomMax,Math.round(zoom*10)/10));
  dialog.querySelector('.r290-view').style.setProperty('--r290-zoom',active.zoom);
  dialog.querySelector('output').textContent=Math.round(active.zoom*100)+'%';
  dialog.querySelector('[data-zoom="-1"]').disabled=active.zoom<=1;
  dialog.querySelector('[data-zoom="1"]').disabled=active.zoom>=config.zoomMax;
 }
 async function setMode(kind){
  if(!active)return;active.kind=kind;setZoom(1);
  const record=dialog._record,ticket=++record.ticket,format=active.format,index=kind==='full'?(active.entryIndex??angles.get(format)??0):0;delete active.entryIndex;stopFlow(record,true);record.rotationIntent=null;
  if(record.format!==format||!record.image.getAttribute('src'))record.image.hidden=true;
  record.surface.setAttribute('aria-busy','true');
  record.enabled=kind==='full';record.format=format;record.index=index;record.wanted=index;
  record.surface.dataset.kind=kind;record.surface.dataset.format=format;record.surface.dataset.frame=String(index);
  dialog.querySelectorAll('.r290-mode').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.kind===kind)));
  dialog.querySelector('.r290-rotate').hidden=!record.enabled;
  dialog.querySelector('[data-hint]').textContent=record.enabled?label('rotateHint'):label('zoomHint');
  record.status.textContent=label('loading');
  try{
   let image;try{image=await load(kind==='full'?frameURL(index,format):paths[format][kind]);}catch(error){if(kind!=='full'||paths[format][kind]===fallback[format]&&!index)throw error;image=await load(fallback[format]);if(ticket===record.ticket){record.index=record.wanted=0;record.surface.dataset.frame='0';}}
   if(ticket!==record.ticket)return;
   record.image.srcset='';record.image.src=image.src;record.image.hidden=false;
   if(kind==='full'){flowState(record);requestMotion(record,index,0,3);}
   record.image.alt=describe(format)+' — '+{full:label('altFull'),label:label('altLabel'),cap:label('altCap')}[kind];
   record.status.textContent='';
  }catch{
   if(ticket!==record.ticket)return;
   if(kind!=='full'){await setMode('full');if(active?.format===format&&active.kind==='full')record.status.textContent=label('detailError');}
   else{record.image.hidden=true;record.status.textContent=label('imageError');}
  }finally{if(ticket===record.ticket)record.surface.setAttribute('aria-busy','false');}
 }
 function open(format,button){
  createDialog();if(dialog.open)return;
  format=String(format);if(!['500','1000'].includes(format))return;
  const entryIndex=sourceAngle(button,format);angles.set(format,entryIndex);
  window.__THREE_OLIVES_270_R2__?.viewer.deactivate({silent:true});
  returnFocus=button;openScroll=window.scrollY;active={format,zoom:1,kind:'full',entryIndex};
  dialog.querySelector('.r290-subtitle').textContent=describe(active.format)+' · '+(active.format==='500'?label('tennis'):label('edition1l'));
  dialog._previousOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';
  dialog.showModal();setMode('full');dialog.querySelector('.r290-close').focus({preventScroll:true});
  // History must exist before open returns, not after visual enhancement's RAF.
  document.dispatchEvent(new CustomEvent('three-olives:gallery-open',{detail:{dialog,format,button}}));
 }
 function switchFormat(format){
  format=String(format);if(!active||!dialog.open||!['500','1000'].includes(format)||active.format===format)return;
  remember();
  active.format=format;
  dialog.querySelector('.r290-subtitle').textContent=describe(format)+' · '+(format==='500'?label('tennis'):label('edition1l'));
  window.__TOS293_FOCUS__?.focus('full');
  setMode('full');
 }
 function addExpand(stage,format){
  if(stage.dataset.r290Expand)return;stage.dataset.r290Expand='true';
  const enclosing=stage.closest('button,a'),parent=enclosing?enclosing.parentElement:stage;
  if(parent.closest('button,a'))return;
  if(getComputedStyle(parent).position==='static')parent.dataset.r290Positioned='';
  const button=document.createElement('button');button.type='button';button.className='r290-expand';button.innerHTML=icon;
  button.setAttribute('aria-label',label('expand')+' '+describe(String(format)));button.setAttribute('aria-haspopup','dialog');
  button.onclick=e=>{e.preventDefault();e.stopPropagation();const src=stage.querySelector('img')?.src||'';open(/1000|triathlon-1l/.test(src)?'1000':String(format),button);};
  parent.append(button);
  const position=()=>{
   const r=stage.getBoundingClientRect();button.hidden=r.width<72||r.height<80;
   if(parent!==stage){const p=parent.getBoundingClientRect();button.style.right='auto';button.style.left=(r.right-p.left-49)+'px';button.style.bottom='auto';button.style.top=(r.bottom-p.top-49)+'px';}
  };
  const observer=new ResizeObserver(position);observer.observe(stage);expanded.set(stage,{observer,button});position();
 }
 function scan(){
  document.querySelectorAll('[data-r290-inline],[data-three-olives-stage][data-three-olives-format="500"]').forEach(stage=>{
   if(records.has(stage))return;const image=stage.querySelector('img');if(!image)return;
   stage.setAttribute('data-r290-inline','');stage.setAttribute('data-three-olives-editorial','');stage.classList.add('three-olives-270');image.classList.add('three-olives-270__poster');
   const turn=document.createElement('button');turn.type='button';turn.className='r290-turn';turn.setAttribute('aria-label',label('inline'));
   const reset=document.createElement('button');reset.type='button';reset.className='r290-reset';reset.hidden=true;reset.textContent=label('reset');
   const status=document.createElement('span');status.className='r290-sr';status.setAttribute('role','status');
   const record={surface:stage,image,reset,status,index:0,wanted:0,ticket:0,format:'500'};records.set(stage,record);
   stage.append(turn,reset,status);bindRotation(turn,record);reset.onclick=e=>{e.stopPropagation();show(record,0);};
  });
  document.querySelectorAll('[data-three-olives-stage],.hero-bottle,.c286-photo').forEach(stage=>{
   const source=stage.querySelector('img')?.getAttribute('src')||'';
   if(!/500|1000|triathlon-1l|tennis/.test(source))return;
   addExpand(stage,/1000|triathlon-1l/.test(source)?'1000':'500');
  });
  for(const [stage,record] of records)if(!stage.isConnected){record.destroy?.();records.delete(stage);}
  for(const [stage,entry] of expanded)if(!stage.isConnected){entry.observer.disconnect();entry.button.remove();expanded.delete(stage);}
 }
 let tick=0;new MutationObserver(()=>{tick ||= requestAnimationFrame(()=>{tick=0;scan();});}).observe(document.body,{childList:true,subtree:true});
 document.addEventListener('click',event=>{
  const button=event.target.closest('[data-3d-open]');if(!button)return;
  event.preventDefault();event.stopImmediatePropagation();
  open(document.querySelector('[data-choice-preview]')?.dataset.format||'500',button);
 },true);
 scan();window.__R290_MEDIA__={records,registerPoster,activateTouch,bindTouchButtons,open,switchFormat,config,version:'298-direct-v1',rotationStats:()=>({decodedBytes:[...motionCache.values()].reduce((n,e)=>n+(e.bytes||0),0),budget:motionBudget,loading:motionLoads,queued:motionQueue.size,cached:motionCache.size,baseReady:Object.fromEntries(['500','1000'].map(format=>[format,[...motionCache.values()].filter(e=>e.format===format&&e.size===motionBase&&e.image).length]))}),get opener(){return returnFocus;},get dialog(){return dialog;},get active(){return active;}};
})();
